export enum AuthChallengeEnum {
  resetPassword = 'resetPassword',
  verifyCredentials = 'verifyCredentials',
  verifyDevice = 'verifyDevice',
  verifyEmail = 'verifyEmail',
  verifyAlternativeStepUpEmail = 'verifyAlternativeStepUpEmail',
  verifyPhoneNumber = 'verifyPhoneNumber',
  verifyForgotPassword = 'verifyForgotPassword',
  verifyChangePassword = 'verifyChangePassword',
  verifyChangeEmail = 'verifyChangeEmail',
  verifyDocument = 'verifyDocument',
  verifyTokenLinkEmail = 'verifyTokenLinkEmail',
}
